<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <van-form @submit="handlerSubmit" @failed="handleFailed">
      <template v-for="(itemT, index) in form.items" :key="index">
        <diy-picker
          title="主办（实施）单位类型"
          :value="itemT.sponsorTypeTxt"
          :list="sponsorTypes"
          :handlerSelect="(key, value) => selectSponsorTypes(key, value, index)"
          :isClick="true"
          :isRequired="itemT.sponsorTypeFlag"
        />
        <van-field
          v-if="itemT.sponsorType == 15"
          required
          v-model="itemT.sponsorTypeOther"
          clearable
          label="其他主办（实施）单位类型"
          placeholder="请输入主办（实施）单位类型"
          :rules="[{ required: true, message: '请填写主办（实施）单位类型' }]"
        />

        <van-field
          required
          v-model="itemT.name"
          clearable
          label="活动（项目）名称"
          placeholder="请输入活动（项目）名称"
          :rules="[{ required: true, message: '请填写活动（项目）名称' }]"
        />
        <diy-picker
          title="活动（项目）主题"
          :value="itemT.activeThemesTxt"
          :list="activeThemes"
          :handlerSelect="(key, value) => selectActiveThemes(key, value, index)"
          :isClick="true"
          :isRequired="itemT.activeThemeFlag"
        />
        <van-field
          v-if="itemT.activeTheme == 10"
          required
          v-model="itemT.activeThemeOther"
          clearable
          label="其他活动（项目）主题"
          placeholder="请输入其他活动（项目）主题"
          :rules="[{ required: true, message: '请填写其他活动（项目）主题' }]"
        />
        <diy-picker
          title="活动类型"
          :value="itemT.activeTypeTxt"
          :list="activeTypes"
          :handlerSelect="(key, value) => selectActiveTypes(key, value, index)"
          :isClick="true"
          :isRequired="itemT.activeTypeFlag"
        />

        <van-field
          v-if="itemT.activeType == 4"
          required
          v-model="itemT.activeTypeOther"
          clearable
          label="其他活动类型"
          placeholder="请输入其他活动类型"
          :rules="[{ required: true, message: '请填写其他活动类型' }]"
        />
        <van-cell
          required
          title="活动起止时间"
          :value="itemT.date"
          @click="itemT.show = true"
          :label="itemT.dateFlag ? '请选择活动起止时间' : ''"
        />
        <!-- allow-same-day 允许起止时间为同一天 -->
        <van-calendar
          :allow-same-day="true" 
          title="活动起止时间"
          v-model:show="itemT.show"
          type="range"
          @confirm="(date) => onDateConfirm(date, index)"
          color="#ff6865"
          :min-date="minDate"
          :max-date="maxDate"
        />
        <van-cell title="活动天数" :value="itemT.days" />
        <van-field
          label="参加队员人数"
          placeholder="请输入参加队员人数"
          v-model.number="itemT.peopleNum"
          type="digit"
          required
          :rules="[
            { required: true, message: '请输入参加队员人数' },
            { validator: validatorNum, message: '参加队员人数的范围是1~10000' },
          ]"
        />

        <van-field
          class="m-b"
          v-model="itemT.remarks"
          clearable
          label="备注"
          placeholder="请输入备注"
          :rules="[{ required: false, message: '请输入备注' }]"
        />
        <div class="btn_r red1" v-if="form.items.length > 1">
          <van-button type="danger" @click="delItem(index)"> 删除 </van-button>
        </div>
      </template>
      <div class="btn_r red">
        <van-button type="warning" @click="addItem"> 添加 </van-button>
      </div>
      <!--登录按钮-->
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit" class="btn btn_dl">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import headers from "@/components/Header";
import diyPicker from "@/components/Select";
import { getsubmitData } from "@/service/form";
import { sponsorTypes, activeThemes, activeTypes } from "@/common/js/field";
import { onSubmit, dateDiff, formatDate, formatIdByTxt, validatorNum } from "@/common/js";
export default {
  name: "addForm6",
  setup() {
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2032, 0, 31),
      form: {
        items: [
          {
            peopleNumShow: false,
            peopleNum: "",
            show: false,
            dateFlag: false,
            date: "请选择",
            days: 0,
            sponsorTypeFlag: false,
            sponsorTypeTxt: "请选择",
            sponsorType: 0,
            activeThemesTxt: "请选择",
            activeThemeFlag: false,
            activeTheme: 0,
            remarks: "",
            activeTypeTxt: "请选择",
            activeTypeFlag: false,
            activeType: 0,
          },
        ],
      },
    });

    onMounted(async () => {
      const { type } = route.query;
      if (type == 1) {
        getInfo();
      }
    });
    const goBack = () => {
      router.go(-1);
    };
    const getInfo = async () => {
      const { id } = route.query;
      const result = await getsubmitData({ dataId: id });
      console.log("result", result);
      const { code, data } = result;
      if (code == 10000 && data) {
        let newObj = { form: {} };
        state.formId = data.formId;
        for (const i of data.list) {
          if (i.fieldCode == "items") {
            let value = i.value;
            // 处理select、date 回显
            for (let c = 0; c < value.length; c++) {
              value[c].activeThemeFlag = false;
              value[c].activeThemesTxt = formatIdByTxt(
                activeThemes,
                value[c].activeTheme
              );
              value[c].peopleNumShow = false;
              value[c].sponsorTypeFlag = false;
              value[c].sponsorTypeTxt = formatIdByTxt(sponsorTypes, value[c].sponsorType);
              value[c].date = `${value[c].startDay}至${value[c].endDay}`;

              value[c].activeTypeFlag = false;
              value[c].activeTypeTxt = formatIdByTxt(activeTypes, value[c].activeType);
            }
            newObj.form[i.fieldCode] = value;
          }
        }
        //   赋值
        Object.assign(state, newObj);
      }
    };

    const addItem = () => {
      state.form.items.push({
        peopleNumShow: false,
        peopleNum: "",
        show: false,
        date: "请选择",
        dateFlag: false,
        days: 0,
        sponsorTypeFlag: false,
        sponsorTypeTxt: "请选择",
        sponsorType: 0,
        activeThemesTxt: "请选择",
        activeThemeFlag: false,
        activeTheme: 0,
        remarks: "",
        activeTypeTxt: "请选择",
        activeTypeFlag: false,
        activeType: 0,
      });
    };

    const selectActiveTypes = (key, value, index) => {
      state.form.items[index].activeType = key;
      state.form.items[index].activeTypeTxt = value;
      state.form.items[index].activeTypeFlag = false;
      if (key != 4) {
        delete state.form.items[index].activeTypeOther;
      }
    };

    const selectSponsorTypes = (key, value, index) => {
      state.form.items[index].sponsorType = key;
      state.form.items[index].sponsorTypeTxt = value;
      state.form.items[index].sponsorTypeFlag = false;
      if (key != 15) {
        delete state.form.items[index].sponsorTypeOther;
      }
    };
    const selectActiveThemes = (key, value, index) => {
      state.form.items[index].activeTheme = key;
      state.form.items[index].activeThemesTxt = value;
      state.form.items[index].activeThemeFlag = false;
      if (key != 10) {
        delete state.form.items[index].activeThemeOther;
      }
    };

    const onDateConfirm = (date, index) => {
      console.log("date", index);
      const [start, end] = date;
      state.form.items[index].show = false;
      state.form.items[index].date = `${formatDate(start)}至${formatDate(end)}`;
      state.form.items[index].startDay = formatDate(start);
      state.form.items[index].endDay = formatDate(end);
      const days = dateDiff(start, end, 1);
      state.form.items[index].days = days;
    };
    const handleFailed = (e) => {
      console.log("handleFailed -> ", e);
    };
    const handlerSubmit = () => {
      const whiteList = [
        "activeThemeFlag",
        "activeThemesTxt",
        "date",
        "dateFlag",
        "peopleNumShow",
        "show",
        "sponsorTypeFlag",
        "sponsorTypeTxt",
        "activeTypeTxt",
        "activeTypeFlag",
      ];
      const { id, type = 0 } = route.query;
      const params = {
        proxy,
        values: state,
        formId: 7,
        nav: goTo,
        white: whiteList,
        type,
        id,
      };

      let sponsorFlag = false,
        activeThemeFlag = false,
        dateF = false;

      let activeTypeF = false;

      const { items } = state.form;

      for (let item of items) {
        if (item.sponsorType <= 0) {
          item.sponsorTypeFlag = true;
          sponsorFlag = true;
        }
        if (item.activeTheme <= 0) {
          item.activeThemeFlag = true;
          activeThemeFlag = true;
        }
        if (item.activeType <= 0) {
          item.activeTypeFlag = true;
          activeTypeF = true;
        }
        if (item.date == "请选择") {
          item.dateFlag = true;
          dateF = true;
        }
      }
      if (sponsorFlag || activeThemeFlag || dateF || activeTypeF) {
        return false;
      }
      onSubmit(params);
    };
    const delItem = (index) => {
      state.form.items.splice(index, 1);
    };
    const goTo = () => {
      console.log("goTo");
      router.push({ path: "/info/wtg" });
    };
    return {
      ...toRefs(state),
      sponsorTypes,
      activeThemes,
      activeTypes,
      handlerSubmit,
      handleFailed,
      selectSponsorTypes,
      selectActiveThemes,
      onDateConfirm,
      addItem,
      delItem,
      goBack,
      selectActiveTypes,
      validatorNum,
    };
  },
  components: {
    headers,
    diyPicker,
  },
};
</script>
<style lang="less" scoped>
:deep(.van-cell__value) {
  flex: 1.3;
}
:deep(.van-field__control) {
  text-align: right;
}
.btn_r {
  margin: 0.12rem;
  display: flex;
  justify-content: flex-end;
}
.red {
  button {
    // border: 0.02667rem solid #ff6865 !important;
    // color: #ff6865;
    height: 0.9rem;
  }
}
.red1 {
  button {
    // border: 0.02667rem solid #dedede !important;
    // color: #dedede;
    // background-color: #fff;
    height: 0.9rem;
  }
}
.m-b {
  margin-bottom: 10px;
}
:deep(.van-cell__label) {
  color: #ee0a24;
}
</style>
